import { ContentType } from '@candu-ai/content/types';

export enum BuiltInComponents {
  Backdrop = 'Backdrop',
  Button = 'Button',
  Card = 'Card',
  CheckList = 'CheckList',
  CheckListItem = 'CheckListItem',
  Collection = 'Collection',
  CollectionItem = 'CollectionItem',
  Column = 'Column',
  Columns = 'Columns',
  ConditionalView = 'ConditionalView',
  ConditionalViewOption = 'ConditionalViewOption',
  Document = 'Document',
  Flow = 'Flow',
  FlowStep = 'FlowStep',
  Form = 'Form',
  FormStep = 'FormStep',
  FormSubmitButton = 'FormSubmitButton',
  FormTextInput = 'FormTextInput',
  FormTextarea = 'FormTextarea',
  FormSelectInput = 'FormSelectInput',
  FormCheckboxList = 'FormCheckboxList',
  FormMultiSelectCardGroup = 'FormMultiSelectCardGroup',
  FormMultiSelectCard = 'FormMultiSelectCard',
  FormSingleSelectCardGroup = 'FormSingleSelectCardGroup',
  FormSingleSelectCard = 'FormSingleSelectCard',
  Hotspot = 'Hotspot',
  HotspotGroup = 'HotspotGroup',
  Link = 'Link',
  List = 'List',
  Image = 'Image',
  ListItem = 'ListItem',
  Modal = 'Modal',
  Multiple = 'Multiple',
  RichTextEditor = 'RichText',
  Variable = 'Variable',
  Text = 'Text',
  Tour = 'Tour',
  TourStep = 'TourStep',
  Typography = 'Typography',
  View = 'View',
}

export const tooltipContentTypes = [ContentType.Tour, ContentType.HotspotGroup];
export const isTooltipContent = (contentType: ContentType | string | undefined) =>
  !!contentType && tooltipContentTypes.indexOf(contentType as ContentType) >= 0;

export const tooltipRootTypes = [BuiltInComponents.Tour, BuiltInComponents.HotspotGroup];
export const isTooltipDocument = (nodeType: BuiltInComponents | string | undefined) =>
  !!nodeType && tooltipRootTypes.indexOf(nodeType as BuiltInComponents) >= 0;

export const tooltipNodeTypes = [BuiltInComponents.Hotspot, BuiltInComponents.TourStep];
export const isTooltipNode = (nodeType: BuiltInComponents | string | undefined) =>
  !!nodeType && tooltipNodeTypes.indexOf(nodeType as BuiltInComponents) >= 0;

export const richTextEditorChildren = [BuiltInComponents.List, BuiltInComponents.Typography];
export const richTextEditorDescendants = [
  ...richTextEditorChildren,
  BuiltInComponents.Text,
  BuiltInComponents.ListItem,
];

export enum TypographyVariants {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  P = 'P',
}

export enum ListVariants {
  OL = 'OL',
  UL = 'UL',
}

/**
 * A list of components that cannot be selected
 */
export const selectionBlacklist: string[] = [
  ...tooltipRootTypes,
  BuiltInComponents.Text,
  BuiltInComponents.Variable,
  BuiltInComponents.Link,
  BuiltInComponents.FormStep,
];

/**
 * A list of components that cannot be edited
 */
export const toolbarBlackList: string[] = [
  BuiltInComponents.FlowStep,
  BuiltInComponents.FormStep,
  BuiltInComponents.Hotspot,
  BuiltInComponents.TourStep,
];

export const componentModifiers: Record<string, string[]> = {
  [BuiltInComponents.FormStep]: ['stepId'],
  [BuiltInComponents.FlowStep]: ['stepId'],
};

export const focusableAtomicNodes = ['Button', 'Badge', 'Alert', 'Code'];

export const focusableNodes = [
  ...focusableAtomicNodes,
  BuiltInComponents.Text,
  BuiltInComponents.Link,
];

export const nodesWithFocusableChild: string[] = [
  ...richTextEditorChildren,
  BuiltInComponents.RichTextEditor,
  BuiltInComponents.ListItem,
];
